import type { RsuiteItemDataTypeMapperFn, TZMap } from '@@partner:types:app'

export const mapTZMapToItemDataType: RsuiteItemDataTypeMapperFn<TZMap> = (
  tzMap: TZMap
) =>
  Object.entries(tzMap).map(([ label, value ]) => ({
    label,
    value
  }))
